import { AfterViewInit, Component, EventEmitter, Inject, NgZone, OnInit, Output } from '@angular/core';
import { QuantumMetricEvents } from 'src/app/_constants/app.constants';
import { ObjectLiteral } from 'src/app/_models/user';
import { MwbScanner, MWBSCANNER } from 'src/app/_models/mwbscanner'
import { AnalyticsService } from 'src/app/_services/sdk/analytics/analytics.service';
import { LanguageService } from 'src/app/_services/api/language/language.service';
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';
import { WelcomeService } from '../_services/welcome.service';

@Component({
  selector: 'ua-barcode-scanner',
  templateUrl: './barcode-scanner.component.html',
  styleUrls: ['./barcode-scanner.component.scss']
})
export class BarcodeScannerComponent implements OnInit, AfterViewInit {


  referenceName = 'uid';
  pageConstants: ObjectLiteral;
  settings: Array<any>
  private isScannerOpen = true;

  @Output('scannerClosed') scannerClosedEmitter = new EventEmitter();
  @Output('scannerTimeout') scannerTimeoutEmitter = new EventEmitter();
  @Output('scannerResult') scannerResultEmitter = new EventEmitter();

  constructor(
    @Inject(MWBSCANNER) private mwbScanner: MwbScanner,
    private ngZone: NgZone,
    private analyticsService: AnalyticsService,
    private languageService: LanguageService,
    private logger: LoggerService,
    private welcomeService: WelcomeService,
  ) {
    this.pageConstants = this.languageService.constants?.boardingPassScanner || {};
   }

  ngOnInit(): void {
    this.logger.debug("BarcodeScannerComponent.ngOnInit", this);
    this.initializeScanner();
  }

  ngAfterViewInit(): void {
    this.logger.debug("BarcodeScannerComponent.ngAfterViewInit", this);
    const self = this
    setTimeout(() => {
      self.mwbScanner.loadSettings(self.settings).then(() => {
        self.startScanning()
      })
    })
  }

  async initializeScanner(){
    this.logger.debug("BarcodeScannerComponent.initializeScanner", this);
    const self = this, mw_c = this.mwbScanner.getConstants()
    this.settings = [
      {"method": "MWBsetActiveCodes"
      ,"value" : [
        mw_c.MWB_CODE_MASK_PDF | 
        mw_c.MWB_CODE_MASK_AZTEC | 
        0x0 //for binary-OR syntax purposes
      ]}
      ,{"method" : "MWBenableHiRes", "value" : [mw_c.CamRes_HD]}
      ,{"method" : "MWBsetOverlayMode", "value" : [mw_c.OverlayModeNone]}
      ,{"method" : "MWBsetDecoderTimeout", "value" : [30]}
      ,{"method" : "MWBsetLevel", "value" : [2]}
      ,{"method" : "MWBsetDpsLimit", "value" : [2]}
      ,{"method" : "MWBenableCameraSwitcher", "value" : [false]}
      ,{"method" : "MWBsetBlinkingLineVisible", "value" : [false]}
      ,{"method" : "MWBenableZoom", "value" : [false]}
      ,{"method" : "MWBenableFlash", "value" : [false]}
      ,{"method" : "MWBenableClose", "value" : [false]}
      ,{"method" : "MWBenableCapturedFrameReturn", "value" : [false]}
      ,{"method" : "MWBsetBlinkingLineVisible", "value" : [false]}
    ];
    if (location.hostname.includes('fiveout.local')) {
      this.mwbScanner.setIcon("/assets/wasm_license_21330.png");
    } else if (location.hostname.includes('vercel.app')) {
      this.mwbScanner.setIcon("/assets/wasm_license_21287.png");
    } else if (location.hostname.includes('united.fiveout.app')) {
      this.mwbScanner.setIcon("/assets/wasm_license_21286.png");
    } else if (location.hostname.includes('united.com')) {
      this.mwbScanner.setIcon("/assets/wasm_license_21279.png");
    }
    this.mwbScanner.setCallback((inp: any) => {
      self.logger.debug("BarcodeScannerComponent.scannerResultFunction", self, inp);
      if(!self.isScannerOpen){
        return;
      }
      try{
        if (inp != undefined && inp.code != null && !['Cancel', 'Error', 'NoResult'].includes(inp.type)) {
          const passenger = inp.code.substring(2, 20);
          const pnr = inp.code.substring(23, 29);
          const lastName = passenger.includes("/") ? passenger.split("/")[0] : "";
          self.analyticsService.sendEvent({
            eventId: QuantumMetricEvents.SCANNER_SUCCESS,
            isConversion: 0,
            value: ''
          });
          self.scannerResultEmitter.emit({
            pnr,
            lastName,
          });
        } else {
          const err = inp && inp.code ? inp.code : 'UNKNOWN_SCANNER_ERROR';
          self.analyticsService.sendEvent({
            eventId: QuantumMetricEvents.SCANNER_ERROR,
            isConversion: 0,
            value: err
          });
          self.scannerResultEmitter.emit(null);
          this.welcomeService.showScanTimeout.next({action:'open', data:{}});
          this.closeScanner()
        }
      } catch(err){
        self.analyticsService.sendEvent({
          eventId: QuantumMetricEvents.SCANNER_ERROR,
          isConversion: 0,
          value: err
        });
        self.scannerResultEmitter.emit(null);
      }      
    })
  }

  startScanning() {
    this.logger.debug("BarcodeScannerComponent.startScanning", this);
    this.mwbScanner.startScanning(10, 20, 80, 60);
  }

  scannerTimeout() {
    this.logger.debug("BarcodeScannerComponent.scannerTimeout", this);
    this.analyticsService.sendEvent({
      eventId: QuantumMetricEvents.SCANNER_TIMEOUT,
      isConversion: 0,
      value: ''
    });
    this.scannerTimeoutEmitter.emit();
  }

  closeScanner(){
    this.logger.debug("BarcodeScannerComponent.closeScanner", this);
    this.isScannerOpen = false;
    this.scannerClosedEmitter.emit();
    this.mwbScanner.closeScanner();
  }

}
